import { ProjectAssets, ImageAssets, VideoAssets, DownloadAssets } from '@models';
import * as Title_01 from './Title_01.png';
import * as Image_01 from './Image_01.png';
import * as Image_02 from './Image_02.png';

export const Title: ImageAssets = {
    Title_01
};

export const Images: ImageAssets = {
    Image_01,
    Image_02
};

export const Videos: VideoAssets = {
    
};

export const Downloads: DownloadAssets = {
    
};

const SpySki: ProjectAssets = {
    Title,
    Images,
    Videos,
    Downloads
};

export default SpySki;